import './App.css';

import {
    BrowserRouter as Router,
    Switch,
    Route,
    Redirect
} from "react-router-dom";
import Home from "./home";
import InvestorNewUserRequest from "./investor/new-user-request";


function App() {
  return (
    <div className="App">
      <Router basename="/hr">
          <Switch>
              <Route exact path="/covid/">
                  <Home />
              </Route>
              <Route exact path="/covid/investor/">
                  <InvestorNewUserRequest />
              </Route>
              <Route exact path="/investor/">
                  <InvestorNewUserRequest />
              </Route>
              {/*<Redirect from="*" to="/covid" />*/}
          </Switch>
      </Router>
    </div>
  );
}

export default App;
